/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import { Icon } from "leaflet";
import RequestLocation from "./request-location";
import { PositionContext } from "../../context/position";
import useSwr from "swr";
import ReactLeafletSearch from "react-leaflet-search";
import Lottie from 'react-lottie';
import { useQuery } from '@apollo/react-hooks';
import { FETCH_FOODBANKS_QUERY } from '../../util/graphql';
import FadeIn from 'react-fade-in';
import * as legoData from '../../assets/lego-loader.json';
import * as travelData from '../../assets/travel-icons.json';
import * as checkData from '../../assets/checked-done.json';

const fetcher = (...args) => fetch(...args).then(response => response.json());

const defaultOptions1 = {
	loop: true,
	autoplay: true,
	animationData: legoData.default,
	renderer: 'svg',
	rendererSettings: {
		preserveAspectRatio: "xMidYMid slice"
	}
};
const defaultOptions2 = {
	loop: true,
	autoplay: true,
	animationData: travelData.default,
	rendererSettings: {
		preserveAspectRatio: "xMidYMid slice"
	}
};
const defaultOptions3 = {
	loop: false,
	autoplay: true,
	animationData: checkData.default,
	rendererSettings: {
		preserveAspectRatio: "xMidYMid slice"
	}
};


const container = {
	height: "90vh",
	width: "100%",
	margin: "0 auto"
};

const foodbankIcon = new Icon({
	iconUrl: require('./foodbank.svg'),
	iconSize: [50, 50]
});

const searchIcon = new Icon({
	iconUrl: require('./redpin.svg'),
	iconSize: [50, 50],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	tooltipAnchor: [16, -28],
	shadowSize: [41, 41]
});

function LeafledMap() {
	const {
		loading,
		data1
	} = useQuery(FETCH_FOODBANKS_QUERY);
	if (!loading) {
		console.log(data1); // I have the data
		// but when I try to access the projects object
	}
	// TODO: Add latitude and longitude to foodbanks data
	const position = React.useContext(PositionContext);
	const url =
		"https://data.police.uk/api/crimes-street/all-crime?lat=52.629729&lng=-1.131592&date=2019-10";
	const { data, error } = useSwr(url, { fetcher });
	const crimes = data && !error ? data.slice(0, 100) : [];
	var foodbanks = crimes;
	// console.log(foodbanks);

	return (
		<>

			{loading ? (
				<>
					<div>
						<h1>Fetching map...</h1>
						<Lottie height={1200} width={1200} options={defaultOptions1} height={120} width={120} />
						<Lottie height={400} width={120} options={defaultOptions2} height={120} width={120} />
					</div>
				</>

			) : (
					<FadeIn>
						<h1>Map is complete.</h1>
						<Lottie height={400} width={400} options={defaultOptions3} height={120} width={120} />
					</FadeIn>
				)}
			{position.latitude === 0 ? (
				<RequestLocation />
			) : (<>
				<Map
					animate={true}
					css={container}
					center={[position.latitude, position.longitude]}
					zoom={15}
				>
					<TileLayer
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
						attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors | <a href="https://freefoodbook.netlify.com">@FoodBook</a>'
					/>
					<Marker position={[position.latitude, position.longitude]}>
						<Popup>
							You are here!
                                <span role="img" aria-label="emoji dot position">🕵</span>
						</Popup>
					</Marker>
					{foodbanks && foodbanks.map(foodbank => (
						<Marker key={foodbank.id} icon={foodbankIcon}
							position={[foodbank.location.latitude, foodbank.location.longitude]}>
							<Popup>Foodbank </Popup>
						</Marker>

					))}
					<ReactLeafletSearch
						inputPlaceholder="Enter address"
						openSearchOnLoad={true}
						markerIcon={searchIcon}
						closeResultsOnClick={true}
						className="customSearchBar" />
				</Map>

			</>

				)}
		</>
	);
}

export default LeafledMap;